import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft } from "lucide-react";

export default function Success() {
  return (
    <div
      data-testid="success-page"
      className="min-h-screen bg-[#F4EBDE] flex items-center justify-center px-6 py-16"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="bg-white rounded-[2rem] p-8 sm:p-10 md:p-14 max-w-xl w-full border border-[#E8DDC9] shadow-[0_20px_60px_rgba(42,48,42,0.08)] text-center"
      >
        <div className="w-14 h-14 mx-auto rounded-full bg-[#849983]/15 flex items-center justify-center">
          <CheckCircle2 className="h-7 w-7 text-[#849983]" />
        </div>
        <h1 className="font-serif-display text-4xl md:text-5xl text-[#2A302A] mt-6 leading-tight">
          ¡Gracias por tu compra!
        </h1>
        <p className="text-[#576057] mt-5 leading-relaxed">
          Tu ebook <strong>«Se Acabó el “No Sé Qué Hacer Hoy”»</strong> ya está en
          camino a tu correo. Revisa tu bandeja de entrada (y la carpeta de spam)
          en los próximos minutos.
        </p>
        <p className="text-[#576057] mt-4 text-sm">
          Si tienes cualquier duda, escríbenos a{" "}
          <a
            href="mailto:contato@pequenosplatos.com"
            className="text-[#849983] underline underline-offset-4"
          >
            contato@pequenosplatos.com
          </a>
        </p>

        <Link
          to="/"
          data-testid="back-home-link"
          className="mt-10 inline-flex items-center gap-2 text-[#849983] hover:text-[#6F856E] font-medium"
        >
          <ArrowLeft className="h-4 w-4" /> Volver al inicio
        </Link>
      </motion.div>
    </div>
  );
}
